import { Vehicle } from '../types/Vehicle';

export const fetchVehicles = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get('/vehiculos');
    return response.data.map(vehicle => new Vehicle(vehicle));
  } catch (error) {
    throw new Error('Error al cargar vehículos');
  }
};

export const createVehicle = async (axiosInstance, vehicleData) => {
  try {
    const response = await axiosInstance.post('/vehiculos', vehicleData);
    return new Vehicle(response.data.vehiculo);
  } catch (error) {
    throw new Error('Error al crear vehículo');
  }
}; 